<template>
	<div class="flex flex-col gap-12">
		<div class="flex flex-col gap-4">
			<AtomTitle
				tag="h2"
				size="md"
			>
				Meer informatie over het gebruik van onze Cookies
			</AtomTitle>
			<p class="mb-4">
				We gebruiken cookies om onze website te monitoren en daarmee te
				kunnen verbeteren. Zo kunnen we bijvoorbeeld zien welke pagina's
				het meest worden bezocht en welke advertenties het meest worden
				aangeklikt. Hierdoor kunnen we onze website blijven verbeteren
				en optimaliseren.
			</p>
			<AtomTitle
				tag="h2"
				size="md"
			>
				Toestemming intrekken
			</AtomTitle>
			<p>
				Ten alle tijden kun je jouw toestemming intrekken. Dit kun je
				doen door op de knop 'Cookie-instellingen' onderaan de pagina te
				klikken en daar jouw voorkeuren aan te passen.
			</p>
		</div>
		<AtomTitle
			tag="h2"
			size="md"
		>
			Partners
		</AtomTitle>
		<section
			v-for="partner in cookieConsentPartners"
			:key="`organism-form-cookie-consent-${partner.label}`"
			class="flex flex-col gap-8 border rounded border-gray-200 bg-black/5 p-8"
		>
			<div class="flex flex-col md:flex-row md:justify-between md:items-center">
				<div class="flex flex-col gap-4 pr-12">
					<LazyAtomTitle
						tag="h2"
						size="sm"
					>
						{{ partner.label }}
					</LazyAtomTitle>
					<p
						class="text-paragraph-size-sm leading-normal"
					>
						{{ partner.description }}
					</p>
					<div class="flex gap-4">
						<span
							v-for="category of partner.categories"
							:key="`organism-form-cookie-partner-category-${category}`"
							class="text-functional-size-xs leading-normal bg-purple-900 rounded-full py-0.5 px-3 text-white"
						>
							{{ category }}
						</span>
					</div>
				</div>
				<div>
					<AtomButton
						v-if="partner.url"
						text="Meer informatie"
						class="text-nowrap"
						:to="{
							title: partner.label,
							url: partner.url,
							newTab: true,
						}"
						:variant="ButtonVariant.Transparent"
						icon-right="fa-up-right-from-square"
						size="sm"
					/>
				</div>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
import { cookieConsentPartners } from '#base/core/consts/cookieConsents';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
</script>
